import React from 'react';
import TubesCursor from '../ui/tubes-curor';

function cricketPublicFile(name) {
  const base = import.meta.env.BASE_URL || '/';
  return base.endsWith('/') ? `${base}${name}` : `${base}/${name}`;
}

/**
 * Mesmo plano de fundo da tela de login: imagem back_log + animação TubesCursor + véu.
 * Coloque dentro de um ancestral `relative` com área definida (ex.: página inteira ou só a gaveta);
 * use `overflow-hidden` no painel da gaveta para não vazar para o canvas.
 */
export default function CricketBrandedBackdrop() {
  const bgUrl = cricketPublicFile('back_log.png');

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      <div
        className="pointer-events-none absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${bgUrl})` }}
      />
      <TubesCursor />
      <div className="pointer-events-none absolute inset-0 cricket-branded-overlay" />
    </div>
  );
}
